/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/* Used for app-wide errors */
export class ErrorHandlingService {
  handleError(errorResponse: HttpErrorResponse): Observable<any> {
    switch (errorResponse.status) {
      // Case statements should look for app-wide and non feature-specific errors
      case HttpStatusCode.InternalServerError: {
        break;
      }
      case HttpStatusCode.Unauthorized: {
        break;
      }
    }
    return throwError(errorResponse);
  }
}
